var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box"},[_c('Userinfo'),_c('Search')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }